var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton, Tooltip } from '@mui/material';
import { grey } from '@mui/material/colors';
var ActivitiesFilterItem = function (_a) {
    var children = _a.children, filterBy = _a.filterBy, sport = _a.sport, chahgeFilterParams = _a.chahgeFilterParams, tooltip = _a.tooltip;
    var isSelected = sport && filterBy.includes(sport);
    return (_jsx(Tooltip, __assign({ title: tooltip, placement: "top" }, { children: _jsx(IconButton, __assign({ onClick: function () { return chahgeFilterParams(sport); }, sx: {
                color: isSelected ? '#dbb400' : 'grey.500',
                backgroundColor: isSelected ? 'rgba(255, 215, 0, 0.1)' : 'transparent',
                border: "1px solid ".concat(isSelected ? '#dbb400' : 'transparent'),
                transition: 'all 0.3s ease',
                '&:hover': {
                    backgroundColor: isSelected ? 'rgba(255, 215, 0, 0.2)' : grey[100],
                    transform: 'scale(1.1)'
                }
            } }, { children: children }), void 0) }), void 0));
};
export default ActivitiesFilterItem;
